import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class Eq5QuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.EQ5;
  displayValue: boolean;
  useValidatedSlider: boolean;
  maxValue: number;
  minValue: number;
  startLabel: string;
  endLabel: string;

  constructor(options: any = {}) {
    super(options);
    this.displayValue = options['displayValue'];
    this.maxValue = options['max'];
    this.minValue = options['min'] ? options['min'] : 0;
    this.startLabel = options['startLabel'];
    this.endLabel = options['endLabel'];
    this.useValidatedSlider =
      options['type'] === 'eq5-validated' ? true : false;
  }
}
